import { apiInstance, gql } from "@/services/httpAdapter";

export async function getMakes() {
	const query = gql`
		query getMakes {
			getMakes {
				make
			}
		}
	`;

	try {
		const response = await apiInstance.post("/graphql", { query });
		return response.data.data?.getMakes;
	} catch (err) {
		throw new Error(err);
	}
}

export async function getModels(make = null) {
	const query = gql`
		query getMakeModel($make: String!) {
			getMakeModel(make: $make) {
				model
			}
		}
	`;

	const variables = {
		make,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getMakeModel;
	} catch (err) {
		throw new Error(err);
	}
}

export async function getModelYears(make = "", model = "") {
	if (!make || !model) {
		return [];
	}

	const query = gql`
		query getMakeModelYear($make: String!, $model: String!) {
			getMakeModelYear(make: $make, model: $model)
		}
	`;

	const variables = {
		make,
		model,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		if (response.data.data?.getMakeModelYear) {
			return response.data.data.getMakeModelYear.map((item) => ({ year: item }));
		}
	} catch (err) {
		throw new Error(err);
	}

	return [];
}

export async function getModelTrims(make, model) {
	const query = gql`
		query getModelTrims($make: String!, $model: String!) {
			getModelTrims(make: $make, model: $model)
		}
	`;

	const response = await apiInstance.post("/graphql", { query, variables: { make, model } });
	return response.data.data?.getModelTrims?.map((trim) => ({ trim })) ?? [];
}
